import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IModalData } from '@core/interfaces/imodal-data';
import { AffiliateService } from '@core/services/affiliate.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription, take } from 'rxjs';
import { ConfirmCancelComponent } from 'src/app/component/shared/confirm-cancel/confirm-cancel.component';
import { IDragDropConfiguration } from '@core/interfaces/idrag-drop-configuration';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-affiliate',
    templateUrl: './affiliate.component.html',
    styleUrls: ['./affiliate.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AffiliateComponent {
  private subscriptions = new Subscription();
  affiliates: any = [];

  isCollapsed = false;
  affiliateData: any;

  configuration: IDragDropConfiguration = {
    imageClass: 'large',
    imagePositionClass: 'd-flex justify-content-center',
    imageTagClass: 'profile-img',
    editable: true
  }

  faPlusSquare = faPlusSquare;

  constructor(
    private toastr: ToastrService,
    private affiliateService: AffiliateService,
    private modal: NgbModal
  ) {}


  ngOnInit(): void {
    this.getAffiliates();
  }

  getAffiliates() {
    this.affiliateService.getAll().pipe(
      take(1)
    ).subscribe((res: any) => this.affiliates = res);
    this.isCollapsed = false;
  }

  addAffiliate() {
    this.isCollapsed =  !this.isCollapsed;
    this.affiliateData = {};
  }

  edit(affiliate: any): void {
    this.affiliateData = affiliate;
    this.isCollapsed = true;
  }

  confirmDelete(data: any): void {
    const modalData: IModalData = {
      title: 'Confirm Delete',
      body: '<p>Are you sure you want to delete this affiliate?</p>',
      cancelBtnText: 'Cancel',
      confirmBtnText: 'Confirm'
    }
    const modalRef = this.modal.open(ConfirmCancelComponent);
    modalRef.componentInstance.data = modalData;
    modalRef.result
      .then((_res: any) => {
        this.affiliateService.deleteAffiliate(data.id, "Affiliate successfully deleted!").pipe(
          take(1)
        ).subscribe((res: any) => this.getAffiliates());
      })
      .catch((_err: any) => false);
  }

  updateAffiliatestOrder(event: any): void {
    this.subscriptions.add(
      this.affiliateService.updateAffiliates(this.affiliates, "Affiliate order successfully updated!").pipe(
        take(1)).subscribe((_res) => false)
    );
  }
  // drop(event: CdkDragDrop<string[]>) {
  //   moveItemInArray(this.affiliates, event.previousIndex, event.currentIndex);
  //   this.affiliates.forEach((aff: any, index: number)=> {
  //     aff.sortOrder = index;
  //   });

  //   this.affiliateService.updateAffiliates(this.affiliates, "Affiliate order successfully updated!").pipe(
  //     take(1)
  //   ).subscribe();
  // }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
